import React, { useState, useEffect } from 'react';
import {
  Text,
  View,
  TouchableOpacity,
  TextInput,
  TouchableWithoutFeedback,
  ActivityIndicator,
} from 'react-native';
import { styless } from './styles';
import './style.scss';
import * as utility from '../../../shared/services/Utility';
import {
  WHITE_COLOR,
  GREY_COLOR,
  SECONDARY_DARK_COLOR,
} from '../../../shared/constants/ColorConstants';
import {
  INTERNET_CHECK,
  EMAIL_REQUIRED,
  INVALID_EMAIL,
} from '../../../shared/constants/Constants';
import { withSnackbar } from 'notistack';

const Modal = ({
  text,
  colorText,
  loading,
  internetCheck,
  sendingPasswordOnEmail,
  modalState,
  enqueueSnackbar,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [sentEmail, setEmailToggle] = useState(false);
  const [emailId, setEmailId] = useState('');
  const [emailError, setEmailError] = useState('');

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);

    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, []);

  const escFunction = (event) => {
    if (event.keyCode === 27) {
      setShowModal(false);
      setEmailToggle(false);
    }
  };

  const statusModal = (value) => modalState(value);
  const openModal = () => {
    setShowModal(true);
    statusModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEmailToggle(false);
    statusModal(false);
    setEmailId('');
  };

  const sendView = () => {
    const emailID = {
      emailId: emailId,
    };
    if (emailID.emailId === '') {
      setEmailError(EMAIL_REQUIRED);
      return;
    } else if (!utility.validEmail(emailID.emailId)) {
      setEmailError(INVALID_EMAIL);
      return;
    }
    if (utility.checkOffline()) {
      enqueueSnackbar(INTERNET_CHECK, {
        variant: 'info',
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
      });
    } else {
      sendingPasswordOnEmail(emailID, (err, message) => {
        if (err) {
          enqueueSnackbar(message, {
            variant: 'error',
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          });
        } else {
          setEmailToggle(true);
        }
      });
    }
  };

  const emailSet = (event) => {
    setEmailId(event);
  };

  const errorStyle = {
    color: 'red',
    fontSize: 12,
    marginTop: '5px',
    textAlign: 'left',
  };
  const modal = showModal ? (
    <div className='modal'>
      <div className='modal-overlay'></div>

      <div className='modal-body'>
        {sentEmail ? (
          <TouchableWithoutFeedback>
            <div className='forgot_form'>
              <img
                src={require('../../../Assets/Images/Icons/envelope_icon.png')}
                alt=''
              />
              <div className='modal-header'>
                <h4>{'Email sent!'}</h4>
                <View style={styless.cancelBtnWrapper}>
                  <TouchableOpacity
                    style={styless.cancelButton}
                    onPress={closeModal}
                  >
                    <i>
                      <img
                        src={require('../../../Assets/Images/Icons/close_icon.png')}
                        alt='close'
                      />
                    </i>
                  </TouchableOpacity>
                </View>
              </div>

              <div className='form-fields'>
                <p>{'Please check your inbox.'}</p>
              </div>
            </div>
          </TouchableWithoutFeedback>
        ) : (
          <TouchableWithoutFeedback
            // pointerEvents="box-only"
            // onPress={closeModal}
          >
            <div className='forgot_form'>
              <div className='modal-header'>
                <h5>{'Forgot Password'}</h5>
                <View style={styless.cancelBtnWrapper}>
                  <TouchableOpacity
                    style={styless.cancelButton}
                    onPress={closeModal}
                  >
                    <i>
                      <img
                        src={require('../../../Assets/Images/Icons/close_icon.png')}
                        alt='close'
                      />
                    </i>
                  </TouchableOpacity>
                </View>
              </div>

              <div className='form-fields'>
                <label>{'Email Address'}</label>
                <div className='form-group'>
                  <TextInput
                    style={styless.textInput}
                    value={emailId}
                    placeholder={'E.g. adrian@gmail.com'}
                    placeholderTextColor={GREY_COLOR}
                    keyboardType='email-address'
                    autoCorrect={false}
                    autoCapitalize='none'
                    autoFocus={true}
                    onChangeText={(text) => {
                      emailSet(text);
                      setEmailError('');
                    }}
                    underlineColorAndroid='transparent'
                    onSubmitEditing={sendView}
                  />
                  <p style={errorStyle}>{emailError}</p>
                </div>

                {/*  <Button
                //     bgColor={SECONDARY_DARK_COLOR}
                //     title={"Click"}
                //     signIn={sendView}
                //     // width={}
                //     // height={}
                //     titleColor={"white"}
                //   /> */}
                <div className='btn-center'>
                  <TouchableOpacity
                    style={{
                      marginTop: 20,
                      backgroundColor: SECONDARY_DARK_COLOR,
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 200,
                      height: 44,
                      borderRadius: 10,
                    }}
                    onPress={sendView}
                  >
                    {loading ? (
                      <ActivityIndicator color={WHITE_COLOR} size={'small'}/>
                    ) : (
                      <Text
                        style={{
                          color: 'white',
                          textAlign: 'center',
                          fontWeight: 'bold',
                        }}
                      >
                        {'Send Email'}
                      </Text>
                    )}
                  </TouchableOpacity>
                </div>
              </div>
            </div>
          </TouchableWithoutFeedback>
        )}

        {/* <button onClick={closeModal}>Close Modal</button> */}
      </div>
    </div>
  ) : null;
  return (
    <>
      <div
        style={{ margin: '5px 0', display: 'inline', cursor: 'pointer' }}
        onClick={openModal}
      >
        <p
          style={{
            color: colorText,
            fontWeight: 'bold',
            display: 'inline',
          }}
        >
          {text}
        </p>
      </div>
      {/* <TouchableOpacity style={{ marginVertical: 5 }} onPress={openModal}>
        <Text style={{ color: colorText, fontWeight: "bold" }}>{text}</Text>
      </TouchableOpacity> */}

      {/* <button onClick={openModal} className="open-modal">
        Forgot Password?
      </button> */}

      {modal}
    </>
  );
};
export default withSnackbar(Modal);
